import React, { useState, useEffect } from 'react';
import { Paper, Button, IconButton, withMobileDialog } from '@material-ui/core';
import Lots from './lots/lots';
import InfoIcon from '@material-ui/icons/Info';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Modal from '../../../../layout/modal/Modal';
import ModelInfo from './modelInfo/ModelInfo';
import ModelInfoDetail from './modelInfo/ModelInfoDetail';
import styles from './Model.module.scss';
import { connect } from 'react-redux';

const Model = (props) => {
	const {
		buildingInfo,
		lots,
		modelKey,
		lotSelectedId,
		lotWithModelSelected,
		elevationRestriction,
		choseFromModel,
		modelLots,
	} = props;

	const [toggleLots, setToggleLots] = useState(false);
	const [lotsList, setLotsList] = useState([]);
	const [price, setPrice] = useState();
	const [modelInfoModal, setModelInfoModal] = useState(false);
	const [modelInfoDetailModal, setModelInfoDetailModal] = useState(false);
	const [modelId, setModelId] = useState('');
	const [elevationId, setElevationId] = useState('');

	useEffect(() => {
		console.log('Lafdkwjf', lotsList);
	}, [lotsList]);

	useEffect(() => {
		if (lotSelectedId) {
			let filterLots = lots.filter(
				(lot) => lot.lot.toString() === lotSelectedId
			);
			setLotsList(filterLots);

			console.log('Im here in if', filterLots);
		} else {
			let filterLots = lots.filter((lot) => {
				if (lot.buildings) {
					return lot.buildings
						?.map((building) => Object.keys(building)[0])
						.includes(modelKey);
				} else {
					return false;
				}
			});
			console.log('Im here in else', filterLots);
			setLotsList(filterLots);
		}
	}, [lots, modelKey, lotSelectedId]);

	useEffect(() => {
		if (lotWithModelSelected?.modelName === modelKey) {
			setPrice(lotWithModelSelected.elevation.price);
		} else {
			setPrice(buildingInfo[modelKey]?.priceList[0].price);
		}
	}, [buildingInfo, modelKey, lotWithModelSelected]);

	useEffect(() => {
		if (lotWithModelSelected?.modelName === modelKey) {
			setToggleLots(true);
		} else {
			setToggleLots(false);
		}
	}, [lotWithModelSelected, modelKey]);

	const openModelInfoModal = () => {
		setModelInfoModal(true);
	};

	const closeModelInfoModal = () => {
		setModelInfoModal(false);
	};

	const openModelInfoDetailModal = () => {
		setModelInfoDetailModal(true);
	};

	const closeModelInfoDetailModal = () => {
		setModelInfoDetailModal(false);
	};

	return (
		<Paper
			variant='outlined'
			// className={styles.model}
			className={`${styles.model}  ${toggleLots ? styles.active : ''}`}
		>
			<div className={styles.model_info_modal}>
				<Modal
					show={modelInfoModal}
					close={closeModelInfoModal}
					title='Model Info'
					wrapperWidth={'95%'}
					wrapperMax={800}
				>
					<ModelInfo
						modelId={modelKey}
						closeModelInfoModal={closeModelInfoModal}
						setModelId={setModelId}
						setElevationId={setElevationId}
						openModelInfoDetailModal={openModelInfoDetailModal}
						lotSelectedId={lotSelectedId}
					/>
				</Modal>
			</div>
			<div className={styles.model_info_detail_modal}>
				<Modal
					show={modelInfoDetailModal}
					close={closeModelInfoDetailModal}
					title='Model Info'
					wrapperWidth={'95%'}
					wrapperMax={800}
				>
					<ModelInfoDetail
						modelId={modelId}
						elevationId={elevationId}
						setModelId={setModelId}
						closeModelInfoDetailModal={closeModelInfoDetailModal}
						openModelInfoModal={openModelInfoModal}
					/>
				</Modal>
			</div>
			<div className={styles.model_header}>
				<h3>{buildingInfo[modelKey]?.name}</h3>
				<IconButton
					className={styles.icon_btn}
					onClick={openModelInfoModal}
				>
					<InfoIcon />
				</IconButton>
			</div>
			<div className={styles.model_content}>
				$ {new Intl.NumberFormat('en-US').format(price)}
			</div>
			<div className={styles.model_footer}>
				<p>
					{buildingInfo[modelKey]?.sqft} sqft{' '}
					{buildingInfo[modelKey]?.bedroomNumber &&
						` | ${buildingInfo[modelKey]?.bedroomNumber} bedrooms`}
				</p>
				<Button
					className={styles.lots_btn}
					endIcon={
						toggleLots ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
					}
					onClick={() => setToggleLots(!toggleLots)}
				>
					Lots
				</Button>
			</div>
			{toggleLots && (
				<Lots
					lotsList={lotsList}
					lots={lots}
					modelKey={modelKey}
					setPrice={setPrice}
					elevationRestriction={elevationRestriction}
					choseFromModel={choseFromModel}
					modelLots={modelLots}
				/>
			)}
		</Paper>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
	lots: state.siteplanManagement.lots,
	lotWithModelSelected: state.siteplanManagement.lotWithModelSelected,
	fitLots: state.siteplanManagement.fitLots,
	fitModels: state.siteplanManagement.fitModels,
});

export default connect(mapStateToProps)(Model);
